import { ChartConfiguration, Color } from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import DeliveryData from '@type/sorr2025/DeliveryData';

type DeliveryChartConfig = {
    data: DeliveryData[];
    chartLabels: string[];
    chartData: number[];
    chartColors: Color[];
};

const deliveryChartConfig = ({
    data,
    chartLabels,
    chartData,
    chartColors,
}: DeliveryChartConfig): ChartConfiguration => {
    const deliveryChartBreakpoint = 1440;
    return {
        type: 'bar',
        data: {
            labels: chartLabels,
            datasets: [
                {
                    //label: 'Values',
                    data: chartData,
                    backgroundColor: chartColors,
                    borderWidth: 1,
                    borderRadius: 4,
                    borderSkipped: false,
                    borderColor: 'rgb(0,0,0)',
                    barThickness: window.innerWidth >= deliveryChartBreakpoint ? 108 : 69,
                    barPercentage: 0.9,
                },
            ],
        },
        options: {
            indexAxis: 'x',
            responsive: true,
            maintainAspectRatio: false,
            scales: {
                x: {
                    beginAtZero: true,
                    display: false,
                },
                y: {
                    beginAtZero: true,
                    display: false,
                },
            },
            plugins: {
                legend: {
                    display: false,
                },
                tooltip: {
                    enabled: false,
                },
                datalabels: {
                    color: 'white',
                    labels: {
                        label: {
                            anchor: window.innerWidth >= deliveryChartBreakpoint ? 'end' : 'start',
                            align: window.innerWidth >= deliveryChartBreakpoint ? 'start' : 'end',
                            // eslint-disable-next-line
                            formatter: (_value: number, context: any) => chartLabels[context.dataIndex],
                            font: {
                                family: 'Graphik',
                                size: window.innerWidth >= deliveryChartBreakpoint ? 14 : 12,
                            },
                            offset: window.innerWidth >= deliveryChartBreakpoint ? 34 : 0,
                            padding: {
                                left: window.innerWidth >= deliveryChartBreakpoint ? 0 : 0,
                            },
                        },
                        value: {
                            anchor: window.innerWidth >= deliveryChartBreakpoint ? 'end' : 'start',
                            align: window.innerWidth >= deliveryChartBreakpoint ? 'start' : 'end',
                            formatter: (value: number) => `${value.toString()}%`,
                            font: {
                                family: 'Graphik Medium',
                                size: window.innerWidth >= deliveryChartBreakpoint ? 26 : 26,
                            },
                            padding: {
                                bottom: window.innerWidth >= deliveryChartBreakpoint ? 0 : 18,
                            },
                        },
                    },
                },
            },
        },
        plugins: [
            ChartDataLabels,
            {
                id: 'drawLogos',
                afterDraw: (chart) => {
                    const { ctx } = chart;
                    const barElements = chart.getDatasetMeta(0).data;

                    // eslint-disable-next-line
                    barElements.forEach((bar: any, index: number) => {
                        const logo = data[index].logo;

                        const logoWidth = window.innerWidth >= deliveryChartBreakpoint ? 69 : 24;
                        const logoHeight = window.innerWidth >= deliveryChartBreakpoint ? 69 : 24;

                        const xPosition =
                            window.innerWidth >= deliveryChartBreakpoint ? bar.x - 14 : bar.x - logoWidth - 10;

                        const yPosition =
                            window.innerWidth >= deliveryChartBreakpoint
                                ? bar.y + bar.height - logoHeight
                                : bar.y - logoHeight / 2;

                        //ctx.drawImage(logo, xPosition, yPosition, logoWidth, logoHeight);
                    });
                },
            },
        ],
    };
};

export default deliveryChartConfig;
